import { useAppSelector } from "shared/utils/redux/hooks";

const useGetUIThemeMode = () => {
  const themeMode = useAppSelector((state) => state.user.themeMode);
  return themeMode;
};
export default useGetUIThemeMode;
